module.exports = __webpack_public_path__ + "static/media/S2N4-4.772a649f.svg";